<template>
  <div id="input-cadastro-busca">
    <!-- ALERT DO SELECT -->
      <div class="btn-group ui-select-oliveira">
        <div :class="alert.tipo" v-show="alert.mostrar">
          <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
          <b>{{ alert.msg }}</b> <span v-show="alert.cadastro"> cadastrado(a).</span>
        </div>
        <!-- INPUT (input-group)( has-error)-->
        <div :class="classFormInput">
          <input v-model="inputBusca"
                 @input="modificarInput" ref='inputBusca'
                 type="text" class="form-control"
                 placeholder="Pesquise o nome"
                 data-toggle="dropdown" aria-haspopup="true"
                 aria-expanded="false">
              <!-- limpar input    -->
              <span class="input-group-btn" v-if="mostrarBtnLimpar">
                <button class="btn btn-default" type="button" @click="limparInput">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </span>
             <!-- carregando -->
             <span class="form-control-feedback" v-if="carregarCombo">
                <i class="fa fa-spinner fa-pulse fa-fw"></i>
             </span>
             <!-- seta para baixo -->
             <span class="form-control-feedback" v-if="mostrarSetinha">
               <i class="fa fa-angle-down" aria-hidden="true"></i>
             </span>
        </div>
        <!-- dropdown  -->
      <ul class="dropdown-menu ui-select-oliveira-drop" :id="nomeInput">
        <!-- lista de itens  -->
        <li v-for="objeto in filteredData">
          <a  @click="setDados(objeto)">
            {{ objeto.nome }}
          </a>
        </li>
        <!-- mostrar mais ou menos itens  -->
        <li v-show="btMostrarMaisMenos">
          <a href="#" id="btn-ui-select-oliveira"
            @click="clickMostrarMais"
            data-toggle="dropdown" :disabled="!noResults">
            <!-- mais -->
            <span class="glyphicon glyphicon-menu-down btn-xs" v-if="mostrarMais"></span>
            <b v-if="mostrarMais">Mostrar mais...</b>
            <!-- menos -->
            <span class="glyphicon glyphicon-menu-up btn-xs" v-if="mostrarMenos"></span>
            <b  v-if="mostrarMenos">Mostrar menos...</b>
          </a>
        </li>
      <!-- cadastro na busca  -->
        <li v-show="noResults">
          <a v-show="!inputBusca">
            <span class="text-primary" >
              Digite um nome e cadastre.
            </span>
          </a>
          <a href="#" id="btn-ui-select-oliveira" v-show="noResults"
              @click="cadastraRapido(selecionado)">
              <span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>
              Cadastrar ( <b>{{ inputBusca }}</b> )
          </a>
        </li>
      </ul>
  </div>
  <br><br>
  <!-- PARA DEGUBAR -->
</div>
</template>
<script>

export default {

  name: "input-cadastro-busca",

  //---------------------------------------------------------------------------
  props: {
      nomeInput :'',
      urlApi :'',
      idModel : ''
  },

  //---------------------------------------------------------------------------
  data: function data() {
    return {
      alert : {
        mostrar: false,
        tipo: 'alert-success ui-select-oliveira-alert',
        msg:'teste componente mensagem'
      },
      listaDados : [{nome:''}],
      inputBusca: '',
      carregarCombo: false,
      selecionado : {nome : ''},
      classFormInput : '',
      setinha : true,
      mostrarBtnLimpar: false,
      qndItensMostrar: 5 //quantidade de intens mostrados no resultado
    }
  },

  //---------------------------------------------------------------------------
  methods: {

    clicouInput(){

    },

    limparInput(){

        this.limparSelecionado()
        this.inputBusca = ''
        this.desativarBtnLimpar()
        $('#' + this.nomeInput).hide()//FECHAR dropdown
        this.$refs.inputBusca.focus()
    },

    modificarInput(){

        this.limparSelecionado()
        if(this.inputBusca === ''){

          this.desativarBtnLimpar()
          this.classFormInput = ''//apaga contorno vermelho no input
          $('#' + this.nomeInput).hide();//FECHAR dropdown

        }else{
          this.ativarBtnLimpar()
          this.$emit('erro-sem-select', true)
          this.classFormInput = 'input-group has-error'//mostra contorno vermelho no input

          $('#' + this.nomeInput).hide();//FECHAR dropdown
          $('#' + this.nomeInput).show();
          $('#' + this.nomeInput).dropdown("toggle");//ABRIR dropdown
        }

    },

    limparSelecionado(){
       let item = { nome : ''}
       this.selecionado = item //local
       this.$emit('setar', null) //componente pai
    },

    setDados(objeto){
        let objetoClone =  _.clone(objeto)

        this.$emit('setar', objetoClone.id) //ATENÇÃO EVENTO EMITIDO PARA COMPONENTE PAI
        this.$emit('erro-sem-select', false)
        this.selecionado = objetoClone
        this.inputBusca = objetoClone.nome
        $('#' + this.nomeInput).hide()//FECHAR dropdown
        this.ativarBtnLimpar()
        this.classFormInput = 'input-group has-success'
        this.timeout = setTimeout(() =>{
          this.classFormInput = 'input-group'
        }, 150)
    },

    clickMostrarMais(){
      this.qndItensMostrar = this.qndItensMostrar == 5 ? 10 : 5
    },

    ativarBtnLimpar(){
        this.classFormInput = 'input-group'
        this.mostrarBtnLimpar = true
    },

    desativarBtnLimpar(){
        this.classFormInput = ''
        this.mostrarBtnLimpar = false
        this.$emit('erro-sem-select', false)
    },

    //CADASTRO AJAX --------------------------------------------------------
    cadastraRapido(objeto){
              this.desativarBtnLimpar()
              this.carregarCombo = true
              objeto.nome = this.inputBusca

              $('#' + this.nomeInput).hide()//FECHAR dropdown

              axios.post(this.urlApi , objeto).then(response =>{

                    this.selecionado = response.data
                    this.inputBusca = response.data.nome
                    this.$emit('setar', response.data.id)
                    this.$emit('erro-sem-select', false)
                    // ALERT
                    this.alert = { mostrar: true, tipo: 'alert-success ui-select-oliveira-alert',
                      msg: response.data.nome + ' cadastrado(a)!'}
                    // TEMPO DE 3 SEGUNDOS
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                      this.alert = { mostrar: false}
                    }, 3000)
                    this.carregarCombo = false
                    this.ativarBtnLimpar()

              }).catch(error =>{

                    this.selecionado = {}
                    this.inputBusca = ''
                    this.$emit('setar', null)
                    this.$emit('erro-sem-select', true)
                    // console.log(error.response.status);
                    if (error.response.status == 422) {
                            // ALERT
                            this.alert = { mostrar: true, tipo: 'alert-warning ui-select-oliveira-alert',
                            msg: 'O limite do seu plano foi atingido'}
                            // TEMPO DE 3 SEGUNDOS
                            clearTimeout(this.timeout);
                            this.timeout = setTimeout(() => {
                              this.alert = { mostrar: false}
                            }, 3000)
                    }else {
                            // ALERT
                            this.alert = { mostrar: true, tipo: 'alert-danger ui-select-oliveira-alert',
                            msg: 'Erro ao salvar ' + error.response.data.errors.nome  }
                            // TEMPO DE 3 SEGUNDOS
                            clearTimeout(this.timeout);
                            this.timeout = setTimeout(() => {
                              this.alert = { mostrar: false}
                            }, 3000)
                    }
                    this.carregarCombo = false
              })
              this.carregarRegistros()
    },
    //FIM CADASTRO AJAX ------------------------------------------------------------

    carregarRegistros(){
        axios.get(this.urlApi).then(response => {
            this.listaDados = response.data
        })
    },

    carregarInput(){
          if (this.idModel) {
              this.carregarCombo = true
              axios.get( this.urlApi + '/' +this.idModel).then(({data}) => {
                  this.selecionado = data
                  this.inputBusca = _.clone(data.nome)
                  this.$emit('setar', data.id)
                  this.$emit('erro-sem-select', false)
                  this.carregarCombo = false
              }).catch(error =>{
                  this.carregarCombo = false
                  this.selecionado = {}
                  this.inputBusca = ''
                  this.$emit('setar', null)
                  this.$emit('erro-sem-select', true)
              })
          }else{
               this.inputBusca = ''
          }
    }

  },
  //---------------------------------------------------------------------------
  computed:{

    filteredData () {
        var filterKey = this.inputBusca && this.inputBusca.toLowerCase()
        var data = this.listaDados
        if (filterKey) {
          data = data.filter(function (row) {
                  return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1
                 })
          })
        }
        return  _.slice(data, 0, this.qndItensMostrar) //limitar resultado lodash
    },

    noResults(){
        return this.filteredData.length == 0 ? true : false
    },

    btMostrarMaisMenos(){
        return this.filteredData.length > 4 ? true : false
    },

    mostrarMais(){
        return this.qndItensMostrar == 5 ? true : false
    },

    mostrarMenos(){
        return this.qndItensMostrar == 10 ? true : false
    },

    mostrarSetinha(){
         return this.carregarCombo == true || this.mostrarBtnLimpar == true ? false : true
    }

  },
  //---------------------------------------------------------------------------
  //observar (criar com o nome na variavel e ele fica monitorando a mesma)
  watch:{

      idModel(){
            this.carregarInput()
      }
  },

  //---------------------------------------------------------------------------
  mounted() {
        this.carregarInput()
        this.carregarRegistros()
  }

}
</script>
<style lang="scss" scoped>

// .btn{
//   border-left: 0px;
//   background: #fff;
// }


.ui-select-oliveira{
 position: relative;
 width: 100%;
 min-width: 100%;
}

.ui-select-oliveira-drop{
 width: 100%;
}
/*MENSAGEM DE CADASTRO*/
.ui-select-oliveira-alert{
 border-radius: 10px;
 position: absolute;
 top: -30px;
 padding: 8px;
 font-size: 12px;
}
/*CAIXA DE DIGITAÇÃO*/
.input-ui-select-oliveira{
 width: 100%;
 margin-bottom: 8px;
}
/*COR DO BOTÃO CADASTRAR E MOSTRAR MAIS*/
#btn-ui-select-oliveira{
 background-color: #e7f7fe;
 color: #1067ad;
}
/*PASSAR MAUSE*/
#btn-ui-select-oliveira:hover{
 background-color: #daeff9;
}

.glyphicon-refresh-animate {
   -animation: spin .7s infinite linear;
   -webkit-animation: spin2 .7s infinite linear;
}
/*animação carregar*/
@-webkit-keyframes spin2 {
   from { -webkit-transform: rotate(0deg);}
   to { -webkit-transform: rotate(360deg);}
}

@keyframes spin {
   from { transform: scale(1) rotate(0deg);}
   to { transform: scale(1) rotate(360deg);}
}


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/especiais/inputCadastroBusca.vue